import type {ReactNode} from 'react';
import {Link} from 'react-router-dom';

import logo from '@/assets/nursio.svg';
import {useGroupAuthorize} from '@/hooks/useAuth';
import {UserGroup} from '@/services/graphqlHooks';
import WorkTimeStatusDropdown from '@/shared/work-time/components/WorkTimeStatusDropdown';
import WorkTimeTrackingBanner from '@/shared/work-time/components/WorkTimeTrackingBanner';
import {cn} from '@/utils/ui';

import FloatingMenu from '../floating-menu/FloatingMenu';
import Copyright from '../footer/Copyright';
import HelpDropdown from '../HelpDropdown';
import IdleTimer from '../IdleTimer';
import MyAccountDropdown from '../MyAccountDropdown';

export type SimpleLayoutProps = {
  children: ReactNode;
  className?: string;
};

const SimpleLayout = ({children, className}: SimpleLayoutProps) => {
  const isRelative = useGroupAuthorize([UserGroup.AuthorizedRelatives]);

  return (
    <div className="flex min-h-full sm:flex-row">
      <div className="flex grow flex-col overflow-hidden max-sm:pb-28">
        <header className="flex flex-0 flex-row items-center gap-2 p-5">
          <Link to="/">
            <img src={logo} alt="Nursiolink" />
          </Link>
          <div className="grow"></div>
          <IdleTimer />
          <WorkTimeStatusDropdown />
          <MyAccountDropdown />
          <HelpDropdown />
        </header>
        <WorkTimeTrackingBanner />
        <main className="flex-1">
          <div className={cn('p-5', className)}>{children}</div>
        </main>
        <footer className="flex-0">
          <Copyright />
        </footer>
      </div>
      {!isRelative && <FloatingMenu />}
    </div>
  );
};

export default SimpleLayout;
